// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import CallErrorPage from './CallErrorPage';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(CallErrorPage);
